import SvgComponentArrow from './SvgComponentArrow';

export default SvgComponentArrow;
